import axios, { AxiosError } from 'axios';

type UpdateStore = {
  id: string;
  chirashiru_store: {
    chirashiru_brand_id: string;
    name: string;
    name_kana: string;
    phone: string;
    homepage: string;
    parking: string;
    electronic_money: string;
    point_card: string;
    credit_card: string;
    business_hours: string;
    regular_holiday: string;
  };
}

function getCsrfToken() {
  return (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
}

function flash(message: string, type: 'info' | 'danger') {
  return `<div id='flash'><div class='alert alert-${type}'>${message}</div></div>`;
}

function createStoreParams(i: number): UpdateStore {
  const params: UpdateStore = {
    id: document.querySelector<HTMLInputElement>(`#stores_${i}_id`)!.value,
    chirashiru_store: {
      chirashiru_brand_id: document.querySelector<HTMLInputElement>(`#stores_${i}_chirashiru_brand_id`)!.value,
      name: document.querySelector<HTMLInputElement>(`#stores_${i}_name`)!.value,
      name_kana: document.querySelector<HTMLInputElement>(`#stores_${i}_name_kana`)!.value,
      phone: document.querySelector<HTMLInputElement>(`#stores_${i}_phone`)!.value,
      homepage: document.querySelector<HTMLInputElement>(`#stores_${i}_homepage`)!.value,
      parking: document.querySelector<HTMLInputElement>(`#stores_${i}_parking`)!.value,
      electronic_money: document.querySelector<HTMLInputElement>(`#stores_${i}_electronic_money`)!.value,
      point_card: document.querySelector<HTMLInputElement>(`#stores_${i}_point_card`)!.value,
      credit_card: document.querySelector<HTMLInputElement>(`#stores_${i}_credit_card`)!.value,
      business_hours: document.querySelector<HTMLInputElement>(`#stores_${i}_business_hours`)!.value,
      regular_holiday: document.querySelector<HTMLInputElement>(`#stores_${i}_regular_holiday`)!.value
    }
  };

  return params;
}

function errorMessage(id: string, name: string, message: string) {
  return `店舗ID: ${id}, 店舗名: ${name}, ${message}`;
}

function isAxiosError(error: any): error is AxiosError<{ message: string }> {
  return !!error.isAxiosError;
}

function pushError(errors: string[], params: UpdateStore, message: string, error?: unknown) {
  if (error && isAxiosError(error) && error?.response?.data.message) {
    const full_message = `${message} ${error.response.data.message}`
    errors.push(errorMessage(params.id, params.chirashiru_store.name, full_message));
  } else {
    errors.push(errorMessage(params.id, params.chirashiru_store.name, message));
  }
}

async function updateStore() {
  const recordNum = document.querySelector<HTMLTableElement>('table')!.rows.length - 1;
  const errorStoreElement = document.querySelector<HTMLElement>('.error_stores');
  const errorStores: string[] = [];
  document.querySelector('.status')!.innerHTML = flash('処理中です... ブラウザバックやリロード等の操作をしないてください。', 'danger');

  for(let i = 0; i < recordNum; i++) {
    const params: UpdateStore = createStoreParams(i);
    const errorStatus = document.querySelector<HTMLInputElement>(`#stores_${i}_error`);
    const statusElement = document.querySelector(`.status_${i}`);

    if (errorStatus?.value === 'true') {
      pushError(errorStores, params, '店舗の更新に失敗しました。');
      continue;
    }

    try {
      await axios.patch(`/staff/api/stores/${params.id}`, params, { headers: { 'X-CSRF-Token': getCsrfToken() }});
      statusElement!.textContent = 'ok';
    } catch (error) {
      statusElement!.textContent = 'error';
      pushError(errorStores, params, '店舗の更新に失敗しました。', error);
    }
  }

  errorStoreElement!.innerText = `更新失敗店舗一覧:\n${errorStores.length > 0 ? errorStores.join('\n') : 'なし'}`;
  document.querySelector('.status')!.innerHTML = flash('更新処理が完了しました。画面下部に更新に失敗した店舗一覧が記載されているので確認してください。', 'info');
}

document.addEventListener('DOMContentLoaded', () => {
  const submitButton = document.querySelector<HTMLButtonElement>('.staff_bulk_update_stores_button');

  submitButton?.addEventListener('click', () => {
    submitButton.disabled = true;
    updateStore();
    window.scroll({ top: 0, behavior: 'smooth' });
  })
})
